import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-juc',
  templateUrl: './juc.component.html',
  styleUrls: ['./juc.component.scss']
})
export class JucComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/juc/juc.component.ts